import { SERVER_URL } from '../constants'
import axios, { AxiosInstance } from 'axios'

export class ServerWalletAPI {
  private readonly axios: AxiosInstance

  constructor() {
    this.axios = axios.create({ baseURL: SERVER_URL })
  }

  async subscribe(email: string): Promise<void> {
    const data = this.axios.post('/api/v1/utils/subscribe', { email })
    console.log(data)
  }
}

const serverWalletAPI = new ServerWalletAPI()

export default serverWalletAPI
